import { render } from "./HomePageFive.vue?vue&type=template&id=2b0d3fa6"
import script from "./HomePageFive.vue?vue&type=script&lang=js"
export * from "./HomePageFive.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\digitaldistribution.io-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__